module.exports = __webpack_public_path__ + "img/sec14mob.ea582a26.png";